import React from 'react';
import {FastField, ErrorMessage} from 'formik';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';
import Error from '../../Error';
import get from 'lodash/get';
import classNames from 'classnames';
import SendProviderParams from './SendProviderParams';

const SendProvider = ({organization, values, errors, touched, intl, setFieldValue, validationSchema}) => {
    return <>
        {organization.sendProviders.length > 0 &&
        <div className="form-group">
            <label className="col-form-label" htmlFor="sef_send-provider">
                <FormattedMessage {...messages.surveys.form.label.sendProvider} />
            </label>
            <FastField name="sendProvider" component="select" id="sef_send-provider"
                className={classNames('form-control', {error: get(errors, 'sendProvider') && get(touched, 'sendProvider')})} >
                <option value="">{intl.formatMessage(messages.surveys.form.label.disabledSendProvider)}</option>
                {organization.sendProviders.map((provider) => (
                    <option key={provider} value={provider} >
                        {intl.formatMessage(messages.admin.organization.sendProviders[provider].name)}
                    </option>
                ))}
            </FastField>
            <ErrorMessage name="sendProvider">{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
            <SendProviderParams values={values} errors={errors} touched={touched} validationSchema={validationSchema} setFieldValue={setFieldValue} />
        </div>}
    </>;
};

export default SendProvider;
